import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enTranslation from "./utils/languageLocators/en.json";
import frenchTranslation from "./utils/languageLocators/fr.json";
import vietnamTranslation from "./utils/languageLocators/vn.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enTranslation },
      french: { translations: frenchTranslation },
      vietnam: { translations: vietnamTranslation },
    },
    fallbackLng: "en",
    debug: false,

    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
